"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = _interopRequireDefault(require("@trs/config"));
var _general = require("@trs/utils/lib/general");
var _Input2 = _interopRequireDefault(require("./Input.style"));
var _InputError = _interopRequireDefault(require("../errors/InputError"));
var _Textarea = _interopRequireDefault(require("./Textarea"));
var _HelpText = _interopRequireDefault(require("./HelpText"));
var _Icon = _interopRequireDefault(require("../icon/Icon"));
var _excluded = ["className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable */

var INPUT_MAX_LENGTH = _config["default"].INPUT_MAX_LENGTH,
  TEXTAREA_MAX_LENGTH = _config["default"].TEXTAREA_MAX_LENGTH;
var Input = /*#__PURE__*/function (_PureComponent) {
  function Input(props) {
    var _this;
    _classCallCheck(this, Input);
    _this = _callSuper(this, Input, [props]);
    _defineProperty(_this, "handleOnChange", function (event) {
      var newEvent = event;
      if (_this.props.type === 'number') {
        var regex = /^-?[0-9]*\.?[0-9]*/;
        var value = event.target.value;
        value = _this.state.isInputFocused ? value : (0, _general.removeNumberFormatting)(value);
        var m = regex.exec(value);
        value = m && m[0] ? m[0] : '';
        newEvent.target.value = value;
      }
      if (_this.props.onChange) {
        _this.props.onChange(newEvent);
      }
    });
    _defineProperty(_this, "formatValue", function (value, type, isInputFocused, withLocaleFormatNumber) {
      if (!withLocaleFormatNumber || isInputFocused || type !== 'number' && type !== 'percentage') return value;
      return type === 'percentage' ? (0, _general.formatNumber)(value).concat('%') : (0, _general.formatNumber)(value);
    });
    _this.state = {
      isInputFocused: false
    };
    return _this;
  }
  _inherits(Input, _PureComponent);
  return _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        clearable = _this$props.clearable,
        classNameProp = _this$props.className,
        disabledProp = _this$props.disabled,
        disableUnderline = _this$props.disableUnderline,
        errors = _this$props.errors,
        fullWidth = _this$props.fullWidth,
        id = _this$props.id,
        icon = _this$props.icon,
        iconClick = _this$props.iconClick,
        _this$props$inputProp = _this$props.inputProps,
        _this$props$inputProp2 = _this$props$inputProp === void 0 ? {} : _this$props$inputProp,
        inputPropsClassName = _this$props$inputProp2.className,
        inputPropsProp = _objectWithoutProperties(_this$props$inputProp2, _excluded),
        multiline = _this$props.multiline,
        name = _this$props.name,
        onBlur = _this$props.onBlur,
        onFocus = _this$props.onFocus,
        onClick = _this$props.onClick,
        onKeyDown = _this$props.onKeyDown,
        onKeyUp = _this$props.onKeyUp,
        onPaste = _this$props.onPaste,
        placeholder = _this$props.placeholder,
        readOnly = _this$props.readOnly,
        required = _this$props.required,
        type = _this$props.type,
        value = _this$props.value,
        helpText = _this$props.helpText,
        scrollable = _this$props.scrollable,
        inputAriaLabel = _this$props.inputAriaLabel,
        submitIconAriaLabel = _this$props.submitIconAriaLabel,
        withLocaleFormatNumber = _this$props.withLocaleFormatNumber;
      var maxLength = this.props.maxLength;
      var InputComponent = 'input';
      var inputProps = _objectSpread({}, inputPropsProp);
      var isNumber = type === 'number' || type === 'percentage';
      var handleOnFocus = function handleOnFocus(ev) {
        _this2.setState({
          isInputFocused: true
        });
        onFocus && onFocus(ev);
      };
      var handleOnBlur = function handleOnBlur(ev) {
        _this2.setState({
          isInputFocused: false
        });
        onBlur && onBlur(ev);
      };
      if (multiline) {
        InputComponent = _Textarea["default"];
        maxLength = maxLength || TEXTAREA_MAX_LENGTH;
      } else {
        InputComponent = _Input2["default"];
        maxLength = maxLength || INPUT_MAX_LENGTH;
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-component"
      }, /*#__PURE__*/_react["default"].createElement(InputComponent, _extends({
        "aria-required": required,
        "aria-label": inputAriaLabel || placeholder,
        autoFocus: autoFocus,
        className: classNameProp,
        clearable: clearable,
        disabled: disabledProp,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        id: id,
        icon: icon,
        name: name,
        onBlur: handleOnBlur,
        onChange: this.handleOnChange,
        onFocus: handleOnFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onPaste: onPaste,
        onClick: onClick,
        placeholder: placeholder,
        readOnly: readOnly,
        type: isNumber ? undefined : type,
        value: this.formatValue(value, type, this.state.isInputFocused, withLocaleFormatNumber),
        hasErrors: Array.isArray(errors) ? errors.length > 0 : !!errors,
        maxLength: maxLength,
        scrollable: scrollable,
        autoComplete: "off"
      }, inputProps)), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        className: "input-icon",
        icon: icon,
        "aria-label": submitIconAriaLabel || 'Submit input content',
        onClick: function onClick() {
          !disabledProp && iconClick('submit');
        },
        disabled: disabledProp
      }), clearable && value && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        id: "".concat(id, "Clear"),
        icon: "ion-android-close",
        className: "input-clear-icon",
        "aria-label": "Clear input",
        onClick: function onClick() {
          !disabledProp && _this2.handleOnChange({
            target: {
              value: ''
            }
          });
          iconClick('clear');
        },
        disabled: disabledProp
      }), errors ? Array.isArray(errors) ? errors.map(function (error, index) {
        return /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
          key: "".concat(index, "-").concat(error),
          id: "".concat(id, "Error").concat(index),
          message: error
        });
      }) : /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        message: errors,
        id: "".concat(id, "Error0")
      }) : null, helpText && !errors.length ? /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
        message: helpText
      }) : null);
    }
  }]);
}(_react.PureComponent);
Input.defaultProps = {
  autoFocus: false,
  className: '',
  placeholder: '',
  clearable: false,
  disableUnderline: false,
  id: '',
  value: '',
  type: 'text',
  disabled: false,
  inputProps: undefined,
  name: undefined,
  icon: undefined,
  maxLength: undefined,
  iconClick: function iconClick() {},
  multiline: false,
  errors: null,
  required: false,
  fullWidth: false,
  readOnly: false,
  onKeyUp: undefined,
  onKeyDown: undefined,
  onFocus: undefined,
  onChange: undefined,
  onBlur: undefined,
  helpText: '',
  scrollable: false,
  inputAriaLabel: '',
  submitIconAriaLabel: '',
  withLocaleFormatNumber: false
};
Input.propTypes = {
  /** If `true`, the input will be focused during the first mount. */
  autoFocus: _propTypes["default"].bool,
  /** The CSS class name of the wrapper element. */
  className: _propTypes["default"].string,
  /** Flag to indicate if the input should have a clearvalue action. */
  clearable: _propTypes["default"].bool,
  /** If `true`, the input will be disabled. */
  disabled: _propTypes["default"].bool,
  /** If `true`, the input will not have an underline. */
  disableUnderline: _propTypes["default"].bool,
  /** If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl. */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** If `true`, the input will take up the full width of its container. */
  fullWidth: _propTypes["default"].bool,
  /** The id of the `input` element. */
  id: _propTypes["default"].string,
  /** An icon name to be rendered next to the input. */
  icon: _propTypes["default"].string,
  /** An action to perform when clicking on the icon on the clear button */
  iconClick: _propTypes["default"].func,
  /** Properties applied to the `input` element. */
  inputProps: _propTypes["default"].shape({}),
  /** If `true`, a textarea element will be rendered. */
  multiline: _propTypes["default"].bool,
  /** Name attribute of the `input` element. */
  name: _propTypes["default"].string,
  /** Action to perform on blur */
  onBlur: _propTypes["default"].func,
  /** Callback fired when the value is changed.
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`. */
  onChange: _propTypes["default"].func,
  /** Action to perform on focus */
  onFocus: _propTypes["default"].func,
  /** Action to perform on key down */
  onKeyDown: _propTypes["default"].func,
  /** Action to perform on key up */
  onKeyUp: _propTypes["default"].func,
  /** The short hint displayed in the input before the user enters a value. */
  placeholder: _propTypes["default"].string,
  /** Flag to indicate if the input is required */
  required: _propTypes["default"].bool,
  /** Flag to indicate if the input is read only */
  readOnly: _propTypes["default"].bool,
  /** Type of the input element. It should be a valid HTML5 input type. */
  type: _propTypes["default"].string,
  /** The input value, required for a controlled component. */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]))]),
  /** The native max length for text area */
  maxLength: _propTypes["default"].number,
  /** Small line of text */
  helpText: _propTypes["default"].string,
  scrollable: _propTypes["default"].bool,
  inputAriaLabel: _propTypes["default"].string,
  submitIconAriaLabel: _propTypes["default"].string,
  withLocaleFormatNumber: _propTypes["default"].bool
};
var _default = exports["default"] = Input;